<template>
  <div class="space-y-8">
    <div
      v-for="(jobs, department) in groupedJobs"
      :key="department"
    >
      <THeading
        tag="h3"
        :level="6"
        class="not-prose text-gray-500"
      >
        {{ department }}
      </THeading>

      <ul
        v-if="jobs.length"
        class="not-prose divide-y divide-gray-100"
      >
        <li
          v-for="job in jobs"
          :key="job.id"
          class="not-prose flex items-center py-4"
        >
          <a
            :href="job.hostedUrl"
            target="_blank"
            class="underline hover:no-underline"
          >
            {{ job.title }}
          </a>
          <span class="ml-auto text-base text-gray-500">{{ job.location }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { JobPosting, JobPostings, Nullable } from '~/types'

const props = defineProps<{
  jobPostings?: Nullable<JobPostings>
}>()

type GroupedJobs = Record<string, JobPosting[]>

// This groups all jobs by department and then moves the "People Operations"
// department to the bottom.
const groupedJobs = computed(() => {
  const groupedJobs = (props.jobPostings?.positions || []).reduce<GroupedJobs>((acc, job) => {
    const { department } = job
    if (!acc[department]) {
      acc[department] = []
    }
    acc[department].push(job)
    return acc
  }, {})

  const orderedGrouped: GroupedJobs = {}
  Object.keys(groupedJobs)
    .sort((a, b) => {
      if (a === 'People Operations') return 1
      if (b === 'People Operations') return -1
      return 0
    })
    .forEach((key) => {
      orderedGrouped[key] = groupedJobs[key]!
    })

  return orderedGrouped
})
</script>
